import { Parser } from 'html-to-react';

interface PromoBadgeLabelProps {
  label: string;
  promoCode?: string;
  isOnSale?: boolean;
}

const htmlToReactParser = new Parser();

/**
 * Component that formats badge label with "Extra" prefix for sale items and bold promo codes.
 *
 * TLDR.: BE sends plain text labels and promo codes separately to avoid
 *        HTML in API responses since the APP also uses the same endpoint.
 */
export const PromoBadgeLabel = ({ label, promoCode, isOnSale }: PromoBadgeLabelProps) => {
  // Find promo code within the label text and wrap it with bold tags
  const promoCodeRegex = new RegExp(`\\b${promoCode}\\b`, 'gi');
  const labelBolded = label.replace(promoCodeRegex, `<b>${promoCode}</b>`);

  // Add "Extra" prefix for sale items
  const badgeLabel = isOnSale ? `Extra ${labelBolded}` : labelBolded;

  // Convert HTML string to React elements using htmlToReact parser
  return htmlToReactParser.parse(badgeLabel);
};
